export default class Mask {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return '9999';
    }

    birthdate() {
        return '19-39-2999';
    }
}
